import Select from '../../fields/SelectBox';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Field, formValueSelector } from 'redux-form';
import { connect, useSelector } from 'react-redux';

import { Checkbox, Flex, Stack } from '@mantine/core';
import Button from '../../elements/Button';
import TextArea from '../../fields/TextArea';
import IconArrowDown from '../../icons/IconArrowDown';

const BlockSubMerchantForm = ({ onClose = () => { }, selectedReason = '', handleSubmit = () => { } }) => {
  const [agreed, setAgreed] = useState(false);

  const { values } = useSelector(
    (state) =>
      state?.form?.BlockSubMerchantForm || {
        values: { reason: '', otherReason: '' },
      }
  );
  const onSubmit = (e) => {
    e.preventDefault();
    handleSubmit(values);
  };

  const handleDisableButton = () => {
    if (selectedReason === 'other') {
      return !agreed || !values?.otherReason;
    }
    return !agreed || !selectedReason;
  };

  return (
    <form onSubmit={onSubmit}>
      <Stack>
        <Field
          component={Select}
          data={[
            {
              label: 'Akun tidak aktif > 1 bulan',
              value: 'akun tidak aktif > 1 bulan',
            },
            {
              label: 'Terdeteksi transaksi anomali',
              value: 'terdeteksi transaksi anomali',
            },
            {
              label: 'Data Subpangkalan tidak tepat',
              value: 'data subpangkalan tidak tepat',
            },
            { label: 'Lainnya', value: 'other' },
          ]}
          inputProps={{
            dropdownPosition: 'bottom',
            rightSection: <IconArrowDown />,
            placeholder: 'Pilih alasan blokir pelanggan',
          }}
          label="Alasan Blokir Subpangkalan"
          name="reason"
        />
        {selectedReason === 'other' && (
          <Field
            component={TextArea}
            helperText="Maksimal 255 karakter"
            inputProps={{
              label: 'Berikan Alasannya',
              placeholder: 'Tulis alasan pemblokiran',
            }}
            maxLength={255}
            name="otherReason"
          />
        )}
        <Checkbox
          label="Saya yakin untuk blokir pelanggan ini"
          onChange={(e) => setAgreed(e.target.checked)}
          styles={{
            body: {
              alignItems: 'center',
            },
            label: {
              color: '#212121',
              fontWeight: 400,
            },
          }}
        />
        <Flex align="center" gap="sm">
          <Button fullWidth onClick={onClose} style="outlined" type="button">
            Batal
          </Button>
          <Button
            disabled={handleDisableButton()}
            fullWidth
            style="danger"
            type="submit"
          >
            Blokir Subpangkalan
          </Button>
        </Flex>
      </Stack>
    </form>
  );
};

BlockSubMerchantForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  onClose: PropTypes.func,
  selectedReason: PropTypes.string,
};

// Selector to get the value of the 'reason' field
const selector = formValueSelector('BlockSubMerchantForm');

const mapStateToProps = (state) => ({
  selectedReason: selector(state, 'reason'),
});

export default connect(mapStateToProps)(BlockSubMerchantForm);
